import { tutorialRoleResolver } from './tutorial-role'
import { tutorialRolesResolver } from './tutorial-roles'
import { tutorialRoleAssignmentsResolver } from './tutorial-role-assignments'
import { listByRolesResolver } from './list-by-roles'
import { updateRoleTutorial } from './update-role-tutorial'

export const Query = {
  ...tutorialRolesResolver,
  ...tutorialRoleResolver,
  ...tutorialRoleAssignmentsResolver,
  ...listByRolesResolver
}

export const Mutation = {
  ...updateRoleTutorial
}
